const HideCard = (props) => {
    const { hide } = props;

    return (
        hide ? null : props.children
    );
};

export default HideCard;
